// services/communication/api.ts
//
// Thin wrapper over the project-wide axios client at lib/api.ts. Every
// communication service file imports `api` from here.

import { api as baseApi } from '@edemics/lib/api'
import axios from 'axios'
import { toast } from 'sonner'

export const COMMUNICATION_BASE = ''
export const api = baseApi

export interface CommApiError {
  statusCode: number
  message: string
  code?: string
}

export function handleApiError(err: unknown, context: string): CommApiError {
  let out: CommApiError
  if (axios.isAxiosError(err)) {
    const body = err.response?.data as any | undefined
    out = {
      statusCode: err.response?.status ?? 0,
      message: body?.message ?? err.message ?? 'Network error',
      code: body?.code,
    }
  } else {
    out = {
      statusCode: 500,
      message: (err as Error)?.message ?? 'Unknown error',
    }
  }
  toast.error(`${context} failed: ${out.message}`)
  return out
}
